import * as React from 'react';
import { History } from 'history';

type Props = {
    classroomId: number;
    history: History;

    classroom?: boolean;
    children?: boolean;
    schedule?: boolean;
};

export default class ClassroomTabs extends React.PureComponent<Props, {}> {
    constructor(props: Props) {
        super(props);

        this.classroom = this.classroom.bind(this);
        this.children = this.children.bind(this);
        this.schedule = this.schedule.bind(this);
    }

    public render() {
        return <ul className="nav nav-tabs d-print-none">
                <li className="nav-item">
                    <a className={`nav-link${this.props.classroom ? ' active' : ''}`} onClick={this.classroom} href="#">Profile</a>
                </li>
                <li className="nav-item">
                    <a className={`nav-link${this.props.children ? ' active' : ''}`} onClick={this.children} href="#">Children</a>
                </li>
                <li className="nav-item">
                    <a className={`nav-link${this.props.schedule ? ' active' : ''}`} onClick={this.schedule} href="#">Schedule</a>
                </li>
            </ul>
    }

    private classroom(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.props.history.push(`/classroom/${this.props.classroomId}`);
    }

    private children(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.props.history.push(`/classroom/${this.props.classroomId}/children`);
    }

    private schedule(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.props.history.push(`/classroom/${this.props.classroomId}/schedule`);
    }
}
